import React from "react"

import SEO from "components/seo"
import ContentfulNavigation from "components/page-components/navigation"
import NotFoundPageContent from "components/404"

const NotFoundPage = () => (
  <>
    <SEO title="404: Not found" />
    <ContentfulNavigation />
    <NotFoundPageContent />
  </>
)

export default NotFoundPage
